<div fxLayout="row" fxLayoutAlign="center center" class="error-page-wrap">
  <mat-card class="error-card">

    <div class="error-hero" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <mat-icon class="error-hero-icon">browser_not_supported</mat-icon>
      </div>
      <div class="error-hero-divider"></div>
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <div class="error-status">UNSUPPORTED<br>BROWSER</div>
      </div>
    </div>

    <mat-card-content class="error-body" fxLayout="column" fxLayoutAlign="center center">
      <p class="error-message">
        This browser is <strong>not supported</strong>.<br>
        Please access this website using Google Chrome, Safari or Microsoft Edge.
      </p>
    </mat-card-content>

  </mat-card>
</div>